import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SocialProof from './components/SocialProof';
import PricingSection from './components/PricingSection';
import WhyChooseUs from './components/WhyChooseUs';
import CompatibleDevices from './components/CompatibleDevices';
import ContentCatalog from './components/ContentCatalog';
import SatisfactionGuarantee from './components/SatisfactionGuarantee';
import WhyDigicode from './components/WhyDigicode';
import WorldCoverage from './components/WorldCoverage';
import FreeTrial from './components/FreeTrial';
import FAQ from './components/FAQ';
import Support from './components/Support';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <HeroSection />
        <SocialProof />
        <PricingSection />
        <FreeTrial />
        <WhyChooseUs />
        <CompatibleDevices />
        <ContentCatalog />
        <SatisfactionGuarantee />
        <WhyDigicode />
        <WorldCoverage />
        <FAQ />
        <Support />
        <CTASection />
      </main>
      <Footer />
      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/12057092376"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Contact via WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl" />
      </a>
    </div>
  );
}
